import React, { useEffect, useMemo, useRef, useState } from "react";
import { IoClose, IoStar } from "react-icons/io5";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  IoMdArrowRoundForward,
  IoMdArrowRoundBack,
  IoMdLogOut,
} from "react-icons/io";
import {
  ChangeTitle,
  dateFormat,
  decrypt,
  getEncodedCookie,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import { apiHeader, getData, postData } from "../../helpers/ApiHelper";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  deleteCookie,
  getCookie,
  setCookie,
} from "../../helpers/CookieComponent";
import { useContactStore } from "../../stores/contactStore";
import { toast } from "react-toastify";

// Formik InitialValues
const initialValues = {
  email: "",
};

// Fromik Validation Schema
const schema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .required("Email is required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email is not valid"
    ),
});

const Home = () => {
  ChangeTitle("Home");
  const [newsUpdateList, setNewsUpdateList] = useState([]);
  const [testimonialList, setTestimonialList] = useState([]);
  const [quickLinkList, setQuickLinkList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [partnerList, setPartnerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const contactList = useContactStore((state) => state.contactList);
  const youtube = contactList?.find((item) => item?.title === "You Tube");
  const linkedin = contactList?.find((item) => item?.title === "LinkedIn");
  const whatsapp = contactList?.find((item) => item?.title === "Whatsapp");
  const telegram = contactList?.find((item) => item?.title === "Telegram");
  const instagram = contactList?.find((item) => item?.title === "Instagram");
  const gmail = contactList?.find((item) => item?.title === "Gmail");
  const facebook = contactList?.find((item) => item?.title === "Facebook");
  const userId = decrypt(getCookie("userId"));
  console.log(userId, "linkedin");
  
  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        email: values.email,
      };

      const response = await postData("sevendayfreetrail/save", param, apiHeader(false));

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        resetForm();
        setLoading(false);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  const newsUpdateSettings = {
    slidesToShow: 1, // Show one slide at a time (usually this is preferred for vertical scroll)
    slidesToScroll: 1, // Scroll one slide at a time
    infinite: true, // Enable infinite scrolling
    autoplay: true, // Autoplay enabled
    autoplaySpeed: 0, // Start immediately
    cssEase: "linear", // Smooth, continuous animation
    speed: 5000, // Total duration of one cycle
    vertical: true, // Enable vertical scrolling
    swipeToSlide: false, // Allow swipe gestures
    arrows: false, // Disable navigation arrows
    adaptiveHeight: true, // Adjust height for each slide if needed
    pauseOnHover: false, // Pause autoplay when mouse hovers
  };
  const homepart1settings = {
    slidesPerRow: 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    arrows: true,
    // dots: true,
    dots: false,
    autoplay: true,
    nextArrow: (
      <div>
        <div className="lg:flex hidden relative top-[-8rem] left-[-3rem] xs:left-[-4.5rem] md:left-[-2.5rem] xl:left-[-4rem] p-[1rem] xs:p-[1.5rem] md:p-[1rem] xl:p-[1.5rem] w-max main-arrow main-arrow2">
          <div className="ma-part p-[.5rem] xs:p-[1rem] md:p-[.5rem] xl:p-[1rem]">
            <IoMdArrowRoundForward className="text-4xl arrow" />
          </div>
        </div>
      </div>
    ),
    prevArrow: (
      <div>
        <div className="lg:flex hidden relative top-[-8rem] p-[1rem] xs:p-[1.5rem] md:p-[1rem] xl:p-[1.5rem] left-0 xs:left-[-.8rem] md:left-0 xl:left-[-.8rem] w-max main-arrow">
          <div className="ma-part p-[.5rem] xs:p-[1rem] md:p-[.5rem] xl:p-[1rem]">
            <IoMdArrowRoundBack className="text-4xl arrow" />
          </div>
        </div>
      </div>
    ),
    responsive: [
      {
        breakpoint: 976,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const testimonialSettings = {
    slidesPerRow: 1,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    arrows: true,
    autoplay: true,
    nextArrow: (
      <div>
        <div className="relative top-[-1.5rem] left-[-4rem] xs:left-[-4.5rem] md:left-[-4rem] p-[1rem] xs:p-[1.5rem] md:p-[1rem] xl:p-[1.5rem] w-max main-arrow main-arrow2">
          <div className="ma-part p-[.5rem] xs:p-[1rem] md:p-[.5rem] xl:p-[1rem]">
            <IoMdArrowRoundForward className="text-4xl arrow" />
          </div>
        </div>
      </div>
    ),
    prevArrow: (
      <div>
        <div className="relative top-[-1.5rem] p-[1rem] xs:p-[1.5rem] md:p-[1rem] xl:p-[1.5rem] left-[1rem] xs:left-[-.8rem] md:left-0 xl:left-[-.8rem] w-max main-arrow">
          <div className="ma-part p-[.5rem] xs:p-[1rem] md:p-[.5rem] xl:p-[1rem]">
            <IoMdArrowRoundBack className="text-4xl arrow" />
          </div>
        </div>
      </div>
    ),
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 976,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const clientSettings = {
    slidesPerRow: 1,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    arrows: true,
    autoplay: true,
    nextArrow: (
      <div>
        <div className="relative top-[-1.5rem] left-[-4rem] xs:left-[-4.5rem] md:left-[-4rem] p-[1rem] xs:p-[1.5rem] md:p-[1rem] xl:p-[1.5rem] w-max bg-white shadow-lg main-arrow main-arrow2">
          <div className="ma-part p-[.5rem] xs:p-[1rem] md:p-[.5rem] xl:p-[1rem]">
            <IoMdArrowRoundForward className="text-4xl bg-white arrow" />
          </div>
        </div>
      </div>
    ),
    prevArrow: (
      <div>
        <div className="relative top-[-1.5rem] p-[1rem] xs:p-[1.5rem] md:p-[1rem] xl:p-[1.5rem] left-[1rem] xs:left-0 w-max bg-white shadow-lg main-arrow">
          <div className="ma-part p-[.5rem] xs:p-[1rem] md:p-[.5rem] xl:p-[1rem]">
            <IoMdArrowRoundBack className="text-4xl bg-white arrow" />
          </div>
        </div>
      </div>
    ),
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 976,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const partnerSettings = {
    slidesPerRow: 1,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    arrows: true,
    autoplay: true,
    nextArrow: (
      <div>
        <div className="relative top-[-1.5rem] left-[-4rem] xs:left-[-4.5rem] md:left-[-4rem] p-[1rem] xs:p-[1.5rem] md:p-[1rem] xl:p-[1.5rem] w-max shadow-lg main-arrow main-arrow2">
          <div className="ma-part p-[.5rem] xs:p-[1rem] md:p-[.5rem] xl:p-[1rem]">
            <IoMdArrowRoundForward className="text-4xl arrow" />
          </div>
        </div>
      </div>
    ),
    prevArrow: (
      <div>
        <div className="relative top-[-1.5rem] p-[1rem] xs:p-[1.5rem] md:p-[1rem] xl:p-[1.5rem] left-[1rem] xs:left-0 w-max shadow-lg main-arrow">
          <div className="ma-part p-[.5rem] xs:p-[1rem] md:p-[.5rem] xl:p-[1rem]">
            <IoMdArrowRoundBack className="text-4xl arrow" />
          </div>
        </div>
      </div>
    ),
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 976,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // News & Update API Call
  const viewNewsUpdateList = async () => {
    var response = await postData("news/list", {}, apiHeader(false));
    console.log(response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const newsupdateData = data.map((data) => {
        return {
          src: data.image,
          title: data.title,
          description: data.description,
          date: data.date,
          link: data.link,
          subTitle: data.subTitle,
          country: data.CountryDetail && data.CountryDetail.countryName,
        };
      });
      setNewsUpdateList(newsupdateData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Quick Link API Call
  const viewQuickLinkList = async () => {
    const param = {
      offset: 0,
      limit: 0,
      term: "",
      sort: "",
      sortBy: "",
    };

    var response = await postData("menu/list", param, apiHeader(false));
    console.log("Menu List", response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      setQuickLinkList(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  const handleClick = (e, item) => {
    // Check if it's Subscriptions and user is not logged in
    if (item.menuName === "Subscriptions" && !userId) {
      e.preventDefault(); // Prevent navigation
      toast.error("Please login first to access Subscriptions");
      // Optional: redirect to login page
      // navigate('/login');
      return;
    }
    // If logged in, normal navigation will happen
  };

  // Testimonial API Call
  const viewTestimonialList = async () => {
    var response = await postData("testimonial/list", {}, apiHeader(false));
    console.log(response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const testimonialData = data.map((data) => {
        return {
          testimonialImage: data.testimonialImage,
          fullName: data.fullName,
          position: data.position,
          description: data.description,
          rating: data.rating,
        };
      });
      setTestimonialList(testimonialData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Client List API Call
  const viewClientList = async () => {
    const param = {
      offset: 0,
      limit: 0,
    };

    var response = await postData("client/image/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      setClientList(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Partner List API Call
  const viewPartnerList = async () => {
    const param = {
      offset: 0,
      limit: 0,
    };

    var response = await postData(
      "partner/image/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      setPartnerList(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewNewsUpdateList();
    viewQuickLinkList();
    viewTestimonialList();
    viewClientList();
    viewPartnerList();
  }, []);

  // Opem Modal Popup Form Function
  const openModal = () => {
    document.body.style.overflowY = "hidden";
    setIsModalOpen(true);
  };

  // Close Modal Popup Form Function
  const closeModal = () => {
    document.body.style.overflowY = "";
    setIsModalOpen(false);
    deleteCookie("log-modal");
    // formikRegister.resetForm();
  };

  const logModal = getCookie("log-modal");

  useEffect(() => {
    if (logModal == "true") {
      openModal();
    }
  }, [logModal]);

  return (
    <>
      {isModalOpen == true && (
        <>
          <div
            onClick={() => closeModal()}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[2%] top-[25%] lg:my-0 relative lg:top-1/2 transform lg:-translate-y-1/2 form-box"
            >
              <div className="flex items-center mb-[5%] justify-end">
                <IoClose
                  onClick={() => closeModal()}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="mb-[10%]">
                <div className="w-full mb-[2%] flex justify-center">
                  {/* <IoMdLogOut className="items-center !rounded-full logout-icon" /> */}
                  <img
                    className="w-[7rem] lg:w-[9rem]"
                    src={toAbsoluteUrl("media/img/icon/basic/logout.svg")}
                    alt=""
                  />
                </div>
                <h1 className="text-center mb-[3%] logout-h1">
                  You have been successfully signed out.
                </h1>
                <p className="text-center w-[90%] mx-auto logout-p">
                  click here to{" "}
                  <Link
                    to="/login"
                    onClick={() => deleteCookie("log-modal")}
                    className="logout-a"
                  >
                    sign in
                  </Link>{" "}
                  again
                </p>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="xxl:container mx-auto w-full h-full lg:h-[50vw] xl:h-[40vw] flex flex-col lg:flex-row home-part1">
        <div className="w-full lg:w-[25%] p-[3%] sm:h-[135vw] lg:h-full newsupdate hp1-part1">
          <h1 className="nu-title mb-[3%] hanson">News & Update</h1>
          {/* <div className="w-full sm:h-[95%] lg:h-[90%] overflow-auto newsupdate-scroll">
            {newsUpdateList.map((data, i) => (
              <>
                <div className="w-full py-[5%] flex flex-col xs:flex-row gap-5 nu-box">
                  <div className="w-[25vw] h-[25vw] sm:w-[15vw] sm:h-[15vw] lg:w-[6vw] lg:h-[6vw]">
                    <img
                      className="w-full h-full"
                      src={data.src}
                      alt="News Image"
                    />
                  </div>
                  <div className="xs:w-[80%]">
                    <h1 className="mb-[2%] nu-part-title">{data.title}</h1>
                    <p className="nu-part-text">{data.description}</p>
                  </div>
                </div>
              </>
            ))}
          </div> */}
          <div className="w-full sm:h-[95%] lg:h-[90%] newsupdate-scroll overflow-hidden">
            {newsUpdateList.length > 0 && (
              <Slider {...newsUpdateSettings}>
                {newsUpdateList.map((data, i) => (
                  <a
                    target="_blank"
                    href={data.link}
                    key={i}
                    className="relative z-[2] w-full py-[5%] flex flex-col xs:flex-row gap-5 cursor-pointer nu-box"
                  >
                    {data.src && (
                      <div className="w-[25vw] h-[25vw] sm:w-[15vw] sm:h-[15vw] lg:w-[6vw] lg:h-[6vw]">
                        <img
                          className="w-full h-full"
                          src={data.src}
                          alt="News Image"
                        />
                      </div>
                    )}
                    <div className="xs:w-[80%]">
                      <p className="mb-[2%] nu-part-text">
                        {dateFormat(data.date)}
                      </p>
                      <p className="mb-[2%] nu-part-title">{data.country}</p>
                      <h1 className="mb-[2%] leading-10 sm:leading-[4rem] lg:leading-10 nu-part-title">
                        {data.title}
                      </h1>
                      <h1 className="mb-[2%] nu-part-title">{data.subTitle}</h1>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: data.description,
                        }}
                        className="mb-[2%] nu-part-text"
                      />
                      <div className="nu-part-text">{data.link}</div>
                    </div>
                  </a>
                ))}
              </Slider>
            )}
          </div>
        </div>
        <div className="w-full relative flex items-center justify-center lg:w-[41%] h-auto hp1-part2">
          {/* <div className="w-full py-[10%] md:py-[5%]">
            <Slider
              className="w-[70%] md:w-[50%] lg:w-[55%] lg:py-0 lg top-[20%] xl:top-[20%] mx-auto cursor-pointer relative z-[1] hp1-part2-imgs"
              {...homepart1settings}
            >
              <div>
                <img
                  className="w-full h-full mb-[5%] "
                  src={toAbsoluteUrl("media/img/newsupdate/2.jpg")}
                  alt="News Image"
                />
                <h1 className="mb-[5%] hp1p2-title">Website features</h1>
              </div>
              <div>
                <img
                  className="w-full h-full mb-[5%] "
                  src={toAbsoluteUrl("media/img/newsupdate/1.jpg")}
                  alt="News Image"
                />
                <h1 className="mb-[5%] hp1p2-title">Why select us</h1>
              </div>
              <div>
                <img
                  className="w-full h-full mb-[5%] "
                  src={toAbsoluteUrl("media/img/newsupdate/3.jpg")}
                  alt="News Image"
                />
                <h1 className="mb-[5%] hp1p2-title">Quick links</h1>
              </div>
            </Slider>
          </div> */}
          <div className="w-full h-full">
            <Slider
              className="w-full h-full mx-auto cursor-pointer relative z-[1] hp1-part2-imgs"
              {...homepart1settings}
            >
              <section className="relative w-full h-full outline-none">
                <img
                  className="w-full h-full"
                  src={toAbsoluteUrl("media/img/newsupdate/1_2.jpg")}
                  alt="News Image"
                />
              </section>
              <section className="relative w-full h-full outline-none">
                <img
                  className="w-full h-full"
                  src={toAbsoluteUrl("media/img/newsupdate/3_2.jpg")}
                  alt="News Image"
                />
              </section>
              <section className="relative w-full h-full outline-none">
                <img
                  className="w-full h-full"
                  src={toAbsoluteUrl("media/img/newsupdate/2_2.jpg")}
                  alt="News Image"
                />
              </section>
            </Slider>
          </div>
        </div>
        <div className="lg:w-[35%] h-auto">
          {/* <img
            className="object-cover w-full h-full"
            src={toAbsoluteUrl("media/img/newsupdate/hp1p3.jpg")}
            alt="News Image"
          /> */}
          <img
            className="w-full h-full"
            src={toAbsoluteUrl("media/img/newsupdate/hp1p3_5.png")}
            alt="News Image"
          />
        </div>
      </div>
      <div className="bg-yellow">
        <div className="xxl:container mx-auto sm:pb-0 pb-[3%] p-[3%] sm:px-[5%] home-quick-link">
          <h1 className="mb-[3%] md:mb-[1%] hanson text-center hql-title">
            Quick link
          </h1>
          <div className="hql-boxs">
            <div className="hql-box"></div>
          </div>
          <div className="flex flex-wrap justify-center gap-4 hql-boxs">
            {quickLinkList.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={(e) => handleClick(e, item)}
                className="px-4 py-2 rounded-md transition hql-link"
              >
                {item.menuName}
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className="w-full p-[3%] sm:p-[5%] h-max home-part2">
        <div className="xxl:container mx-auto">
          <div className="relative lg:w-[70%] mb-[5%] p-[4%] md:p-[2%] lg:p-[1.5%] mx-auto hp2-part1">
            <h1 className="mb-[1%] text-center sevendayfreetrial hanson">
              7 Day free trial
            </h1>
            <img
              className="mb-[1%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
            <h2 className="mb-[1%] unlocksevenday outfit">
              Unlock seven (7) days of exclusive access to the most
              comprehensive tax law database.
            </h2>
            <h3 className="w-[80%] gainsevenday outfit">
              Gain uninterrupted access to an extensive, authentic collection of
              tax laws and regulations.
            </h3>
            <h3 className="w-[80%] mb-[1%] gainsevenday outfit">
              Explore the database with complete freedom for seven (7) days and
              stay ahead with the most reliable legal resources.
            </h3>
            <form action="" onSubmit={formik.handleSubmit}>
              <div className="flex w-full">
                <input
                  className="w-[70%] px-[2%] py-[1%] hp2p1-email outfit"
                  type="email"
                  placeholder="Enter email"
                  id="email"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                />
                <button
                  type="submit"
                  className="w-[30%] p-[1%] flex flex-col justify-around text-center sevenday-btn"
                >
                  <h3 className="w-full">Full website access</h3>
                  <h1 className="w-full hanson">7-Day free trial</h1>
                </button>
              </div>
              {formik.touched.email && formik.errors.email && (
                <div className="mt-2 error-msg">
                  <div className="">{formik.errors.email}</div>
                </div>
              )}
            </form>
          </div>
          <div className="w-full mb-[5%] lg:w-[90%] mx-auto flex flex-col md:flex-row gap-10 hp2-part2">
            <Link
              to="/articlelist"
              onClick={() => setCookie("menu", "Article", {})}
              className="md:w-[50%] text-center hp2p2p1"
            >
              <div className="">
                <h2 className="w-full mb-[5%] hanson">Latest article</h2>
                <div className="w-full">
                  <img
                    className="w-full"
                    src={toAbsoluteUrl("media/img/law-symbol/symbol1.svg")}
                    alt=""
                  />
                </div>
              </div>
            </Link>
            <Link
              to="/articlelist"
              onClick={() => setCookie("menu", "Article", {})}
              className="md:w-[50%] text-center hp2p2p1"
            >
              <div className="">
                <h2 className="w-full mb-[5%] hanson">Most viewed</h2>
                <div className="w-full">
                  <img
                    className="w-full"
                    src={toAbsoluteUrl("media/img/law-symbol/symbol2.svg")}
                    alt=""
                  />
                </div>
              </div>
            </Link>
          </div>
          <div className="hp2-part3 pb-[10%] md:pb-0">
            <h1 className="mb-[3%] md:mb-[1%] hanson text-center">
              Testimonial
            </h1>
            <img
              className="mb-[5%] md:mb-[1%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
            <div className="w-full relative testimonial">
              <div className="w-[90%] md:w-full mx-auto">
                <Slider
                  className="w-full h-max md:w-[90%] mx-auto cursor-pointer"
                  {...testimonialSettings}
                >
                  {testimonialList.map((data, i) => (
                    <>
                      <div className="w-full h-full flex gap-5 p-[2%] pb-[5%] testimonial-box">
                        <div className="w-[10rem] h-[10rem] tbp1">
                          <img
                            className="w-full h-full"
                            src={data.testimonialImage}
                            alt="Testimonial Image"
                          />
                        </div>
                        <div className="w-[80%] tbp2">
                          <h1 className="hanson">{data.fullName}</h1>
                          <h3 className="mb-[2%]">{data.position}</h3>
                          <p className=" mb-[5%]">{data.description}</p>
                          <div className="flex gap-1">
                            {[...Array(Number(data.rating))].map((data) => (
                              <IoStar className="text-4xl tb-star" />
                            ))}
                          </div>
                        </div>
                      </div>
                    </>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="relative z-[2] home-part3">
        <div className="xxl:container mx-auto">
          <div className="h-[45vw] sm:h-[40vw] md:h-[50vw] lg:h-[43vw] xl:h-full w-full relative bg-img-client">
            <img
              className="h-full w-full object-cover"
              src={toAbsoluteUrl("media/img/bg/bg-home-client.svg")}
              alt=""
            />
          </div>
          <div className="xxl:container mx-auto absolute w-full top-0 py-[5%] hp3-client1">
            <h1 className="mb-[2%] md:mb-[1%] hanson text-center">
              GCC Law Help
            </h1>
            <p className="text-center mb-[1%] hp3-client1-p">
              Follow social media to get daily news and updates.
            </p>
            <img
              className="mb-[3%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-white.svg")}
              alt=""
            />
            <div className="w-full hp3c1-social">
              <div className="flex w-[90%] lg:w-[80%] gap-6 sm:gap-10 justify-center mx-auto itmes-center">
                <a
                  target="_blank"
                  href={linkedin?.detail}
                  // href="https://www.linkedin.com/in/gcc-law-help-81b433329"
                  className="w-[10%] sm:w-[7%] flex flex-col gap-2 items-center cursor-pointer"
                >
                  <div className="w-full">
                    <img
                      className="w-[100%] mx-auto p-[20%] hp3c1s-box"
                      src={toAbsoluteUrl(
                        "media/img/icon/social-media/Linkedin2.svg",
                      )}
                      alt="LinkedIn"
                    />
                  </div>
                  <h2 className="hp3c1sb-h2">Linkedin</h2>
                </a>
                <a
                  target="_blank"
                  href={facebook?.detail}
                  // href="https://www.facebook.com/profile.php?id=61560058082077"
                  className="w-[10%] sm:w-[7%] flex flex-col gap-2 items-center cursor-pointer"
                >
                  <div className="w-full">
                    <img
                      className="w-[100%] mx-auto p-[20%] hp3c1s-box"
                      src={toAbsoluteUrl(
                        "media/img/icon/social-media/Facebook2.svg",
                      )}
                      alt="Facebook"
                    />
                  </div>
                  <h2 className="hp3c1sb-h2">Facebook</h2>
                </a>
                <a
                  target="_blank"
                  href={whatsapp?.detail}
                  // href="https://chat.whatsapp.com/LK86GdKTnD073Ut9HyI7mu"
                  className="w-[10%] sm:w-[7%] flex flex-col gap-2 items-center cursor-pointer"
                >
                  <div className="w-full">
                    <img
                      className="w-[100%] mx-auto p-[20%] hp3c1s-box"
                      src={toAbsoluteUrl(
                        "media/img/icon/social-media/Whatsapp2.svg",
                      )}
                      alt="WhatsApp"
                    />
                  </div>
                  <h2 className="hp3c1sb-h2">Whatsapp</h2>
                </a>
                <a
                  target="_blank"
                  href={telegram?.detail}
                  // href="https://t.me/+iP3Dw_JNpGYyMWE1"
                  className="w-[10%] sm:w-[7%] flex flex-col gap-2 items-center cursor-pointer"
                >
                  <div className="w-full">
                    <img
                      className="w-[100%] mx-auto p-[20%] hp3c1s-box"
                      src={toAbsoluteUrl(
                        "media/img/icon/social-media/Telegram2.svg",
                      )}
                      alt="Telegram"
                    />
                  </div>
                  <h2 className="hp3c1sb-h2">Telegram</h2>
                </a>
                <a
                  target="_blank"
                  href={youtube?.detail}
                  // href="https://www.youtube.com/channel/UCXTG9LAJGUeiDHsE8NQBkAg"
                  className="w-[10%] sm:w-[7%] flex flex-col gap-2 items-center cursor-pointer"
                >
                  <div className="w-full">
                    <img
                      className="w-[100%] mx-auto p-[20%] hp3c1s-box"
                      src={toAbsoluteUrl(
                        "media/img/icon/social-media/Youtube2.svg",
                      )}
                      alt="YouTube"
                    />
                  </div>
                  <h2 className="hp3c1sb-h2">Youtube</h2>
                </a>
                <a
                  target="_blank"
                  href={instagram?.detail}
                  // href="https://www.instagram.com/gcclawhelp?igsh=dTI2ZzZ4cjU2bXJ4"
                  className="w-[10%] sm:w-[7%] flex flex-col gap-2 items-center cursor-pointer"
                >
                  <div className="w-full">
                    <img
                      className="w-[100%] mx-auto p-[20%] hp3c1s-box"
                      src={toAbsoluteUrl(
                        "media/img/icon/social-media/Instagram2.svg",
                      )}
                      alt="Instagram"
                    />
                  </div>
                  <h2 className="hp3c1sb-h2">Instagram</h2>
                </a>
                <a
                  target="_blank"
                  href={gmail?.detail}
                  // href="https://groups.google.com/g/gcc-law-01"
                  className="w-[10%] sm:w-[7%] flex flex-col gap-2 items-center cursor-pointer"
                >
                  <div className="w-full">
                    <img
                      className="w-[100%] mx-auto p-[20%] hp3c1s-box"
                      src={toAbsoluteUrl(
                        "media/img/icon/social-media/Mail2.svg",
                      )}
                      alt="Gmail"
                    />
                  </div>
                  <h2 className="hp3c1sb-h2">Gmail</h2>
                </a>
              </div>
            </div>
          </div>
          <div className="xxl:container mx-auto md:absolute z-[2] w-full md:bottom-[-15vw] lg:bottom-[-10vw]">
            <div className="md:w-[70%] mx-auto py-[5%] md:py-[3%] bg-client">
              <h1 className="mb-[3%] md:mb-[1%] hanson text-center">
                Our valuable client
              </h1>
              <img
                className="mb-[3%] md:mb-[1%] mx-auto"
                src={toAbsoluteUrl("media/img/titledesign/t-blue.svg")}
                alt=""
              />
              <div className="w-full relative client">
                <div className="w-[90%] mx-auto">
                  <div className="w-full">
                    <Slider
                      className="h-max w-[90%] mx-auto cursor-pointer"
                      {...clientSettings}
                    >
                      {clientList.map((data) => (
                        <>
                          <div className="w-full h-full flex gap-5 p-[2%] pb-[5%] client-logo">
                            <img
                              className="w-full"
                              src={data.clientImage}
                              alt=""
                            />
                          </div>
                        </>
                      ))}
                    </Slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="relative pb-[5%] pt-[5%] md:pt-[20vw] lg:pt-[15vw] home-part4">
        <div className="xxl:container mx-auto">
          <h1 className="mb-[3%] md:mb-[1%] hanson text-center">
            Our valuable partners
          </h1>
          <img
            className="mb-[5%] md:mb-[1%] mx-auto"
            src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
            alt=""
          />
          <div className="w-full relative z-[2] partner">
            <div className="w-[90%] mx-auto">
              <Slider
                className="h-max w-[90%] mx-auto cursor-pointer"
                {...partnerSettings}
              >
                {partnerList.map((data, i) => (
                  <>
                    <div className="w-full h-full flex gap-5 p-[2%] pb-[5%] client-logo">
                      <img className="w-full" src={data.partnerImage} alt="" />
                    </div>
                  </>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Home;
